export class AndroidPaymentSDK {
  private callbacks: {};
  private callbackId: number;
  constructor() {
    this.callbacks = {};
    this.callbackId = 0;

    // Setup the callback handler
    (<any>window).androidPaymentCallback = (response) => {
      // Native Android bridge objects don't serialize — parse if string, otherwise copy fields
      let parsed = response;
      if (typeof response === 'string') {
        try { parsed = JSON.parse(response); } catch (e) { parsed = { raw: response }; }
      }

      const callback = this.callbacks[parsed.callbackId];
      if (callback) {
        if (parsed.success) {
          callback.resolve(parsed.data);
        } else {
          // Build a plain error string from whatever the native layer provides
          const errorDetail = parsed.error || parsed.errorMessage || parsed.message
            || parsed.data || parsed.reason || parsed.code
            || (typeof response === 'string' ? response : 'Unknown reader error');
          callback.reject(errorDetail);
        }
        delete this.callbacks[parsed.callbackId];
      }
    };
  }

  discoverReaders() {
    return new Promise((resolve, reject) => {
      const id = this.callbackId++;
      this.callbacks[id] = { resolve, reject };
      (<any>window).AndroidPayment.discoverReaders(id.toString());
    });
  }

  scanQRCode() {
    return new Promise((resolve, reject) => {
      const id = this.callbackId++;
      this.callbacks[id] = { resolve, reject };
      (<any>window).AndroidPayment.scanQRCode(id.toString());
    });
  }
  showSettings() {
      (<any>window).AndroidPayment.showSettings();
  }

  disconnectReader() {
    return new Promise((resolve, reject) => {
      const id = this.callbackId++;
      this.callbacks[id] = { resolve, reject };
      (<any>window).AndroidPayment.disconnectReader(id.toString());
    });
  }

  connectReader(serialNumber) {
    return new Promise((resolve, reject) => {
      const id = this.callbackId++;
      this.callbacks[id] = { resolve, reject };
      (<any>window).AndroidPayment.connectReader(serialNumber, id.toString());
    });
  }

  collectPayment(amountCents, currency = 'usd') {
    return new Promise((resolve, reject) => {
      const id = this.callbackId++;
      this.callbacks[id] = { resolve, reject };
      (<any>window).AndroidPayment.collectPayment(amountCents, currency, id.toString());
    });
  }
}
